export interface TemplateTileSpec {
    name: string;
    templateID: string | undefined;
    color: string;
    icon: string;
    iconColor: string;
    targetOwnerID?: string;
    privateProTrial: boolean;
}

function getFirstRunTemplate(templateID: string, isProd: boolean): TemplateTileSpec | undefined {
    return getFirstRunTemplateSpecs(isProd).find(ts => ts.templateID === templateID);
}

export function isFirstRunTemplate(templateID: string, isProd: boolean): boolean {
    const frt = getFirstRunTemplate(templateID, isProd);
    return frt !== undefined;
}

export function isPrivateProTrialTemplate(templateID: string, isProd: boolean): boolean {
    const frt = getProTrialTemplateSpecs(isProd).find(ts => ts.templateID === templateID);
    return frt !== undefined && frt.privateProTrial;
}

// FIXME: return empty or some to disable feature
export function getFirstRunTemplateSpecs(isProd: boolean): TemplateTileSpec[] {
    // FIXME: Right now on staging we alway copy the same template
    // Once we sync templates from prod to staging, we should be able to get rid
    // of this hack.
    return [
        {
            name: "Directory",
            templateID: isProd ? "employees-template" : "mseQORRs19Go51DHXV2C-template",
            color: "#F4BC2A",
            icon: "employee-directory",
            iconColor: "#FFFFFF",
            privateProTrial: false,
        },
        {
            name: "Conference",
            templateID: isProd ? "conference-template" : "mseQORRs19Go51DHXV2C-template",
            color: "#3199FF",
            icon: "conference",
            iconColor: "#FFFFFF",
            privateProTrial: false,
        },
        {
            name: "Expenses",
            templateID: isProd ? "basic-expense-reporter-template" : "mseQORRs19Go51DHXV2C-template",
            color: "#299B5E",
            icon: "expense-report",
            iconColor: "#FFFFFF",
            privateProTrial: false,
        },
        {
            name: "Issues",
            templateID: isProd ? "issue-tracker-template" : "mseQORRs19Go51DHXV2C-template",
            color: "#ED7A11",
            icon: "issue-tracker",
            iconColor: "#FFFFFF",
            privateProTrial: false,
        },
        {
            name: "Tasks",
            templateID: isProd ? "task-tracker-template" : "mseQORRs19Go51DHXV2C-template",
            color: "#8782F7",
            icon: "template-classic-tasks",
            iconColor: "#FFFFFF",
            privateProTrial: false,
        },
    ];
}

export function getProTrialTemplateSpecs(isProd: boolean): TemplateTileSpec[] {
    return [
        {
            name: "Delivery",
            templateID: isProd ? "GgThzACoDde6qnQs8tzH-template" : "ctJlkTnJ35QhiuH8njD5-template",
            color: "#5278FF",
            icon: "template-pro-pickup-dropoff",
            iconColor: "#FFFFFF",
            privateProTrial: true,
        },
        {
            name: "Field Sales",
            templateID: isProd ? "UuclrXH1gmva6SkjQB71-template" : "ctJlkTnJ35QhiuH8njD5-template",
            color: "#9766FF",
            icon: "template-pro-field-sales",
            iconColor: "#FFFFFF",
            privateProTrial: true,
        },
        {
            name: "Inventory",
            templateID: isProd ? "ENDIKfoIiQEQ17snKZmt-template" : "ctJlkTnJ35QhiuH8njD5-template",
            color: "#FC5083",
            icon: "template-pro-inventory",
            iconColor: "#FC5083",
            privateProTrial: true,
        },
        {
            name: "Property Management",
            templateID: isProd ? "jwautCA3CiD5k3ZqIH44-template" : "ctJlkTnJ35QhiuH8njD5-template",
            color: "#FF6B62",
            icon: "template-pro-property-management",
            iconColor: "#FFFFFF",
            privateProTrial: true,
        },
        {
            name: "CRM",
            templateID: isProd ? "l8XaRYH35zW9phHw03R3-template" : "ctJlkTnJ35QhiuH8njD5-template",
            color: "#FFA530",
            icon: "template-pro-crm",
            iconColor: "#FFFFFF",
            privateProTrial: true,
        },
    ];
}
